export const FIXED_STICKY_FOOTER_HEIGHT = '5.313rem';
export const FIXED_TOAST_HEIGHT = '3.15rem';
